export const DEFAULT_URL = `${process.env.NEXT_PUBLIC_WORDPRESS_URL}`;
export const DEFAULT_ENDPOINT = `${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}`;

export const fixedPages = [
  'home',
  'about',
  'news',
  'players',
  'roster',
  'contact',
  'standings',
  'stats',
  'schedule',
  'leaderboard',
];
